import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useVerifyEmailOtp({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({ otp, email }: { otp: string; email: string }) => {
    const response = await httpClient.post('auth/user/change-email/verify', {
      code: otp,
      email,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
    onSuccess: (res, variables) => {
      toast.success('Email updated successfully')
      queryClient.invalidateQueries({ queryKey: ['current-user'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
